<template>
  <!-- Whether to show the component or not -->
  <div data-vuetify :class="{ hide: !isActive }">
    <v-app>
    <v-main>
      <v-app-bar flat color="white" elevation="2">
        <v-spacer/>
        <!--
        @slot The title text
        -->
        <v-toolbar-title><slot>Administration<br /> Console</slot></v-toolbar-title>
        <v-spacer />
        <v-spacer />
        <BaseCrossrefLogoStacked />
        <v-spacer/>
      </v-app-bar>
      <v-col cols="12">
        <v-card elevation="6" v-if="deployEnvNotProduction">
          <v-card-text><b>{{ deployEnv }}</b></v-card-text>
        </v-card>
      </v-col>
      <v-container
        class="fill-height splash-screen-background"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="6"
            lg="4"
          >
            <!--
            Hide the login screen
            @event loginScreenDeactivate
            -->
            <LoginBox @loginScreenDeactivate="handleDeactivate"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-sheet min-height="50%"></v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
  </div>
</template>

<script>
/**
 * The root component used in the existing Admin System/webDeposit auth UI integrations.
 */
import { interpret } from 'xstate'
import { toggleLoginScreenMachine } from '@/machines/toggleLoginScreenMachine'
import LoginBox from '@/components/regular/LoginBox'
import BaseCrossrefLogoStacked from '@/components/base/BaseCrossrefLogoStacked'
export default {
  name: 'LoginScreen',
  components: { BaseCrossrefLogoStacked, LoginBox },
  props: {
    /**
     * Whether to display the component when it first loads
     */
    showOnLoad: {
      type: Boolean,
      default: true
    },
    /**
     * Whether to show the non-vue page content (if congigured) on load
     */
    showToggleContentOnLoad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Is the login screen visible
     */
    isActive: function () {
      return this.current.matches('active')
    },
    /**
     * Is the non-vue page content visible
     */
    toggleContentActive: function () {
      return this.current.matches('inactive')
    },
    /**
     * The CSS display property applied to the non-vue page content
     */
    toggleContentDisplayProperty: function () {
      return this.toggleContentActive ? 'block' : 'none'
    },
    deployEnvNotProduction: function () {
      return this.deployEnv !== 'production'
    }
  },
  data () {
    return {
      /** Interpret the machine and store it in data */
      toggleService: interpret(toggleLoginScreenMachine),

      /** Start with the machine's initial state */
      current: toggleLoginScreenMachine.initialState,

      /** Start with the machine's initial context */
      context: toggleLoginScreenMachine.context,
      toggleContentSelector: this.$root.config.authLoginScreenToggleContentSelector,
      deployEnv: this.$root.config.deployEnv
    }
  },
  created () {
    /** Start FSM service on component creation */
    this.toggleService
      .onTransition(state => {
        /** Update the current state component data property with the next state */
        this.current = state
        /** Update the context component data property with the updated context */
        this.context = state.context
      })
      .start()
    /**
     * If the app is configured to show the Login Screen on load, send the relevant event to the state machine
     */
    if (typeof this.$root.config.loginScreen.showOnLoad === 'boolean') {
      const msg = this.$root.config.loginScreen.showOnLoad ? 'ACTIVATE' : 'DEACTIVATE'
      this.send(msg)
    }
    /**
     * If there is non-vue page content configured, create the event listeners to listen to (de)activate events
     */
    if (this.toggleContentSelector) {
      const toggleContentElem = document.querySelector(this.toggleContentSelector)
      if (toggleContentElem !== null) {
        const self = this
        window.addEventListener('loginScreenActivate', function () { self.toggle('ACTIVATE') })
        window.addEventListener('loginScreenDeactivate', function () { self.toggle('DEACTIVATE') }, false)
        window.addEventListener('toggleLoginScreen', function () { self.toggle() }, false)
        document.querySelector(this.toggleContentSelector).style.display = this.toggleContentDisplayProperty
      }
    }
  },
  methods: {
    /** Send events to the toggleLoginScreenMachine service */
    send (event) {
      this.toggleService.send(event)
    },
    /**
     * Toggle the display of the Login Screen (and non-vue page content, if defined)
     * @param state
     */
    toggle (state) {
      const msg = state || 'TOGGLE'
      this.send(msg)
      if (typeof this.toggleContentSelector === 'string' && this.toggleContentSelector.length > 0) {
        document.querySelector(this.toggleContentSelector).style.display = this.toggleContentDisplayProperty
      }
    },
    /**
     * Called in response to the loginScreenDeactivate event from the window
     */
    handleDeactivate () {
      if (this.toggleContentSelector) {
        this.send('DEACTIVATE')
      }
    }
  }
}
</script>

<style scoped>
  .hide {
    display: none;
  }
  .splash-screen-background {
    /*background: url("/img/wilson-ye-GeOws83toxc-unsplash.jpg") no-repeat center center;*/

    background: url('~@/assets/images/Login/src_assets_images_Login_PR_Banner_2.png') no-repeat center center;
    /*background-size: cover;*/
    background-position: top;
  }
</style>
